export default __webpack_public_path__ + "static/media/react.becbab0a.png";